export function getToday() {
	let timeZoneOffset = new Date().getTimezoneOffset() * 60000;
	let today = new Date(Date.now() - timeZoneOffset).toISOString();

	today = today.split('T')[0];
	
	return today;
}